import React from 'react'
import { Show, TextField, DateField } from '@refinedev/antd'
import { useShow, useOne } from '@refinedev/core'
import { Typography } from 'antd'
import type { Tables } from '@muaa/shared'

type Job = Tables<'jobs'>
type Profile = Tables<'profiles'>

const { Title } = Typography

export function JobShow() {
  const { query } = useShow<Job>()
  const isLoading = query.isLoading
  const record = query.data?.data

  const { query: profileQuery } = useOne<Profile>({
    resource: 'profiles',
    id: record?.posted_by ?? '',
    meta: { idColumnName: 'user_id' },
    queryOptions: { enabled: !!record?.posted_by },
  })

  return (
    <Show isLoading={isLoading}>
      <Title level={5}>Role</Title>
      <TextField value={record?.role ?? '—'} />

      <Title level={5}>Organization</Title>
      <TextField value={record?.org ?? '—'} />

      <Title level={5}>Location</Title>
      <TextField value={record?.loc ?? '—'} />

      <Title level={5}>Posted By</Title>
      <TextField value={profileQuery.data?.data?.name ?? record?.posted_by ?? '—'} />

      <Title level={5}>Created</Title>
      {record?.created_at ? (
        <DateField value={record.created_at} format="MMM D, YYYY h:mm A" />
      ) : (
        <TextField value="—" />
      )}
    </Show>
  )
}
